import { useNavigate } from "react-router-dom";
import EmailPasswordForm from "@/components/EmailPasswordForm";

export default function LoginPage({ initialMode = "login" }) {
  const navigate = useNavigate();

  // NOTE: connexion Google désactivée temporairement (voir wiki/decisions/2026-08-12-auth-google-direct).
  // Le flux backend est prêt (endpoints /api/auth/google/login + /callback) ; pour la réactiver :
  // remettre le bouton ci-dessous + les identifiants Google dans backend/.env.

  const handleEmailSuccess = (_user) => {
    // L'app utilise déjà localStorage.session_token + redirige vers /dashboard
    navigate('/dashboard', { replace: true });
  };

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left - Hero Video */}
      <div className="hidden lg:flex lg:w-1/2 relative items-end p-12 overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
          data-testid="hero-video"
        >
          <source src="/hero-video.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
        <div className="relative z-10 text-white max-w-lg">
          <img src="/veyer-ciel-logo.png" alt="Véyèr CIEL" className="h-14 mb-6 drop-shadow-lg" />
          <p className="text-lg text-white/80 leading-relaxed" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
            Détection intelligente des parcelles agricoles de La Réunion et Mayotte par imagerie satellite
          </p>
        </div>
      </div>

      {/* Right - Auth */}
      <div className="flex-1 flex items-center justify-center px-6 py-12" style={{ background: '#F9F8F6' }}>
        <div className="w-full max-w-md space-y-6">
          {/* Logo */}
          <div className="space-y-3 text-center">
            <img src="/veyer-ciel-logo.png" alt="Véyèr CIEL" className="h-20 mx-auto" />
            <h1 className="text-xl font-bold tracking-tight" style={{ fontFamily: 'Manrope, sans-serif', color: '#1A1A1A' }}>Véyèr CIEL</h1>
            <p className="text-xs" style={{ color: '#4A4A4A', fontFamily: 'IBM Plex Sans, sans-serif' }}>
              Plateforme de détection et suivi des parcelles agricoles
            </p>
          </div>

          {/* Connexion Google retirée temporairement — voir wiki/decisions/2026-08-12-auth-google-direct */}

          {/* Email/password form */}
          <div className="bg-white border border-black/5 rounded-2xl p-5 shadow-sm">
            <EmailPasswordForm onSuccess={handleEmailSuccess} initialMode={initialMode} />
          </div>

          <p className="text-center text-[10px]" style={{ color: '#7A7A7A' }}>
            Biomyr · La Réunion &amp; Mayotte
          </p>
        </div>
      </div>
    </div>
  );
}
